import {inject, Injectable} from "@angular/core";
import {
    ActionService,
    collection,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";

export class PendingOrderData extends EntityData<PendingOrderData> {
    @field requestId: string;
    @field storeId: number;
}

export class PendingOrdersData extends EntityData<PendingOrdersData> {
    @collection(PendingOrderData) pendingOrders: PendingOrderData[];
}

@Injectable({providedIn: "root"})
export class PendingOrdersService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- PendingOrdersService");

        super(http, nameSpace, "app-pending-orders", configService, useAsync, actionNames);
    }
}
